const LeagueSpectatorsPageReducer = (state, action) => {
  switch (action.type) {
    case 'LEAGUE_SPECTATORS_META_LEAGUE_UPDATE':
      return {...state, metaLeague: action.data};
    case 'LEAGUE_SPECTATORS_FETCHING':
      return {...state, isFetching: true};
    case 'LEAGUE_SPECTATORS_UPDATE':
      return {...state, items: action.data, isFetching: false};
    default:
      return state;
  }
};

export {LeagueSpectatorsPageReducer};
